import { motion, AnimatePresence } from 'framer-motion'
import { useSelector } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import { Route, Switch, Redirect } from 'react-router-dom'
import { FeatureDict, selectFeatureIncludes } from '@authed/selectors'
import { ApprovalsContainer } from './approvalsContainer'
import { PendingAndDraftsContainer } from './pendingAndDraftsContainer'
import { SubmissionsHeaderContainer } from './submissionsHeaderContainer'
import { MainTabHolder } from '../../components/tab-layouts/main-tab-holder'
import { MainTabsAreaWithHeader } from '../../components/tab-layouts/main-tabs-area'
import { DatasetDetails } from '../../datasets/dataset-details'
import { Search } from '../search/search'
import { Submissions } from '../submissions/submissions'
import { TemplatesByFolder } from '../templates/templatesByFolder'

export const Home = (props: RouteComponentProps) => {
  const { location } = props
  const [DATASETS_PAGE_ENABLED = false] = useSelector(
    selectFeatureIncludes([FeatureDict.DATASETS_PAGE]),
  )

  return (
    <motion.div
      className="submissions"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.15 } }}
      exit={{ opacity: 0, transition: { duration: 0.15 } }}
    >
      <SubmissionsHeaderContainer location={location} />
      <MainTabHolder>
        <MainTabsAreaWithHeader>
          <div style={{ height: '100%', overflow: 'hidden' }}>
            <AnimatePresence exitBeforeEnter initial={false}>
              <Switch key={location.pathname} location={location}>
                {DATASETS_PAGE_ENABLED ? null : (
                  <Route path="/codes/templates" component={TemplatesByFolder} />
                )}
                <Route path="/codes/submissions" component={Submissions} />
                <Route path={['/codes/pending', '/codes/drafts']}>
                  <PendingAndDraftsContainer />
                </Route>
                <Route
                  path={['/codes/approval/:datasetId/review', '/codes/approval']}
                  component={ApprovalsContainer}
                />
                <Route path="/codes/search" component={Search} />
                <Route path="/codes/details/:id" component={DatasetDetails} />
                <Redirect from="/codes/submitted/:id" to="/codes/details/:id/data" />
              </Switch>
            </AnimatePresence>
          </div>
        </MainTabsAreaWithHeader>
      </MainTabHolder>
    </motion.div>
  )
}
